//server
// export const VUE_APP_API = "http://192.168.0.74/work/mythical-beast";
export const VUE_APP_API = "https://www.ctrls.com.tw/mythical_beast/api";

/*
TypeError: Cannot read properties of null (reading 'classList')
    at BeastDetailPreview.vue:140:28
* */
